namespace $.$$ {
	export class $shm_hitalama_benchmarks_page_metrics extends $.$shm_hitalama_benchmarks_page_metrics {
		override Cell(id: {row: string[], col: string}) {
			if (id.col === 'Удалить') return this.Delete(id.row.at(-1)!)
			return id.col === 'Компьютер' ? this.Details(id) : super.Cell(id)
		}
		indexed_column(id: string) {
			return id === 'Первый поиск индексированного свойства, с'
		}
		delete_enabled(id: string) { return this.record(id)['Удалить'] === true }
		override col_head_content(id: string) {
			return this.indexed_column(id) ? ['Первый поиск\nиндексированного\nсвойства, с'] : [id]
		}
		details_computer(id: {row: string[], col: string}) {
			const meta = this.record(id.row.at(-1)!)[id.col] as $shm_hitalama_benchmarks_archive_meta
			return meta.computer || 'Не указаны'
		}
		details_browser(id: {row: string[], col: string}) {
			const meta = this.record(id.row.at(-1)!)[id.col] as $shm_hitalama_benchmarks_archive_meta
			return meta.browser || 'Не указан'
		}
	}
}
